import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  rightButton: {
    marginLeft: "10px",
  },
}));

export default styles;
